/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import classname from 'classnames';
import * as React from 'react';
import { useState } from 'react';
import ReactHtmlParser from 'react-html-parser';

import { ITextBlockViewProps } from '@msdyn365-commerce-modules/text-block/src/modules/text-block/./text-block';

import { ITextBlockProps } from '../definition-extensions/text-block.ext.props.autogenerated';

const TextBlockView: React.FC<ITextBlockViewProps & ITextBlockProps<{}>> = props => {
    const truncateText = props.config.truncateText || false;
    const {
        config: { textColor, textAlignment }
    } = props;
    const [displayTruncateParagraph, setDisplayTruncateParagraph ] = useState(truncateText);
    const onClick = () => setDisplayTruncateParagraph(!displayTruncateParagraph);
    const paragraphObject = Object.assign({props}, props.paragraph);
    const paragraphText = (Object.entries(paragraphObject))[0][1].text;

    const truncateTextFunction = (inputText:string, letterLimit: number) => {
        let startIndex = 0;
        for(let i = 1; i < inputText.length; i++){
            if(inputText[i] === '>'){
                startIndex = i+1;
                break;
            }
        }
        const stack = [];
        let letterCount = 0;
        for(let i = startIndex; i < inputText.length; i++){
            if(letterCount === letterLimit){
                return inputText.slice(startIndex, i+1);
            }
            else if(inputText[i] === '<'){
                stack.push(inputText[i]);
            }
            else if(inputText[i] === '>'){
                stack.pop();
            }
            else if(stack.length === 0){
                letterCount++;
            }
        }
        return '';
    };

    const htmlToDisplay = paragraphText && truncateTextFunction(paragraphText,180);
    const colorOfText = textColor ? `font-${textColor}` : '';
    return(
    <div className={props.className} id={props.id} {...props.renderModuleAttributes(props)}>
        {(displayTruncateParagraph) ?
            <div>
                <p className={classname(textAlignment ? `text-${textAlignment}` : '', colorOfText)}>
                    {ReactHtmlParser(htmlToDisplay)}
                    <span className='ms-footer__show-more-text-connect'>...<button onClick={onClick} className={`ms-footer__show-more-text ${colorOfText}`}>Show More</button></span>
                </p>
            </div>
            : <span className={classname(textAlignment ? `text-${textAlignment}` : '', colorOfText)}>{props.paragraph}</span>
        }
    </div>
    );
};

export default TextBlockView;
